import {
    CONFIRMATION_ON_SALES,
    PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON,
    PRIMARY_BUSINESS_ADDRESS,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyLicence/TDILicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatTDI = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    licence = {
        id: 'telecommunication-dealers-individual',
        formID: 'telecommunication-dealers-individual',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${CONFIRMATION_ON_SALES}-do-you-intend-to-sell-m2m-equipment`]:
                licenceDetails?.confirmationOnSalesOfM2MProhibitedTelecommunicationEquipmentOrSm?.doYouIntendToSellM2MEquipment ?? '-',
            [`${CONFIRMATION_ON_SALES}-do-you-intend-to-sell-prohibited-telecommunication-equipment`]:
                licenceDetails?.confirmationOnSalesOfM2MProhibitedTelecommunicationEquipmentOrSm
                    ?.doYouIntendToSellProhibitedTelecommunicationEquipment ?? '-',
            [`${CONFIRMATION_ON_SALES}-do-you-intend-to-sell-sms-sim-box`]:
                licenceDetails?.confirmationOnSalesOfM2MProhibitedTelecommunicationEquipmentOrSm?.doYouIntendToSellSmsSimBox ?? '-',

            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-name`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.name ?? '-',
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-designation`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.designation ?? '-',
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-email`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.email ?? '-',
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-office-tel-number`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.officeTelNumber ?? '-',
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-mobile-number`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.mobileNumber ?? '-',

            [`${PRIMARY_BUSINESS_ADDRESS}-building-name`]: licenceDetails?.BusinessLocation[0]?.address?.buildingName ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-postal-code`]: licenceDetails?.BusinessLocation[0]?.address?.postalCode ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-street-name`]: licenceDetails?.BusinessLocation[0]?.address?.streetName ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-block-house-no`]: licenceDetails?.BusinessLocation[0]?.address?.blockNo ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-floor-level-optional`]: licenceDetails?.BusinessLocation[0]?.address?.floor ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-unit-optional`]: licenceDetails?.BusinessLocation[0]?.address?.unit ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const tdiPayload = {
    formatTDI
};

export default tdiPayload;
